import React from 'react';
import R from 'ramda';
import { FontIcon } from 'material-ui';
import TcDayPickerSet from '../../../tc-ui/date-picker-set';
import DateUtils from '../../../../utils/date-utils';
export default ({ dates, contractingPeriod, onChange, forSaleDates, disabled }) => (<div>
  {
    dates.map((dateRange, index) => {
      const currentFromDate = R.prop('fromDate', dateRange);
      const currentToDate = R.prop('toDate', dateRange);
      const initialStartDateMonth = (() => {
        if (dateRange.fromDate) return dateRange.fromDate;
        if (dateRange.toDate) return dateRange.toDate;
        if (forSaleDates) return new Date();
        if (dates.length > 1 && index) return R.path([index - 1, 'toDate'], dates) || R.path([index - 1, 'fromDate'], dates);
        return contractingPeriod.startDate;
      })();
      const initialEndDateMonth = (() => {
        if (dateRange.toDate) return dateRange.toDate;
        if (dateRange.fromDate) return dateRange.fromDate;
        if (dates.length > 1 && index) return R.path([index - 1, 'toDate'], dates) || R.path([index - 1, 'fromDate'], dates);
        return contractingPeriod.startDate;
      })();
      const startDateEnableFrom = (() => {
        if (forSaleDates) {
          if (new Date() < new Date(initialStartDateMonth)) return new Date();
          return initialStartDateMonth;
        }
        return contractingPeriod.startDate;
      })();
      return (
        <div key={index}>
          <TcDayPickerSet
            endDateCloseOnSelect
            startDateCloseOnSelect
            startDateDisabled={disabled}
            endDateDisabled={disabled}
            disableDeleteButton={dates.length === 1}
            style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}
            startDateContainerStyle={{ display: 'inline-block', width: '45%' }}
            startDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
            endDateContainerStyle={{ display: 'inline-block', width: '45%' }}
            endDateTextFieldStyle={{ width: '100%', fontSize: '12px' }}
            addButtonStyle={{ position: 'relative', marginLeft: '4%', visibility: disabled ? 'hidden' : 'visible' }}
            deleteButtonStyle={{ position: 'relative' }}
            startDateFloatingText="From"
            endDateFloatingText="To"
            initialStartDateMonth={initialStartDateMonth}
            startDateEnableFrom={startDateEnableFrom}
            startDateEnableTo={contractingPeriod.endDate}
            initialEndDateMonth={initialEndDateMonth}
            endDateEnableFrom={dateRange.fromDate || contractingPeriod.startDate}
            endDateEnableTo={contractingPeriod.endDate}
            startDate={currentFromDate}
            endDate={currentToDate}
            onChangeStartDate={(date) => onChange([index, 'fromDate'], date)}
            onChangeEndDate={(date) => onChange([index, 'toDate'], date)}
            onDelete={() => onChange([], R.remove(index, 1, dates))}
            onAdd={() => onChange([], R.insert(index + 1, {}, dates))}
          />
          {
            dateRange.fromDate && dateRange.toDate && !disabled && !forSaleDates
            && DateUtils.notInContractingPeriod([dateRange], contractingPeriod.startDate, contractingPeriod.endDate) ?
              (
                <div style={{ color: '#f44336', fontSize: '12px', display: 'flex', width: '80%', alignItems: 'center', marginBottom: '12px' }}>
                  <FontIcon className="tc-icon-report" style={{ color: '#f44336', marginRight: '4px' }}/>
                  Not in contracting period, please UPDATE or REMOVE
                </div>
              ) : <span/>
          }
          {
            forSaleDates && disabled && (
              <small>
                We do not allow customized sale dates for stay pay offers at the moment.
              </small>
            )
          }
        </div>
      );
    })
  }
</div>);



// WEBPACK FOOTER //
// ./src/app/components/contracting/generic-components/special-offer-tables/travel-sales-dates-pickers.jsx